export default __webpack_public_path__ + "static/media/algodao_c1_ou_c2.bc324f09.png";